module.exports = __webpack_public_path__ + "static/media/ticket-red.87d6bcfd.svg";